function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import Plugin from './plugin';
/**
 * @module DismissableComponent
 * @since  0.2.0
 * @author  Thomas Erbe <vizuaalog@gmail.com>
 */

var DismissableComponent = /*#__PURE__*/function (_Plugin) {
  _inherits(DismissableComponent, _Plugin);

  var _super = _createSuper(DismissableComponent);

  /**
   * Plugin constructor
   * @param  {string} name Plugin's name
   * @param  {Object} options Plugin's options
   * @return {this} The new plugin instance
   */
  function DismissableComponent(name, options) {
    var _this;

    _classCallCheck(this, DismissableComponent);

    _this = _super.call(this, options);
    /**
     * The name of this component, this will be used as the root class
     * @type {string}
     */

    _this.name = name;
    /**
    * Body text.
    * @type {string}
    */

    _this.body = _this.option('body');
    /**
    * Color modifier.
    * @type {string} Possible values are null, primary, info, success, warning, danger
    */

    _this.color = _this.option('color');
    /**
    * How long to wait before auto dismissing the component.
    * @type {int|null} If null component must be dismissed manually.
    */

    _this.dismissInterval = _this.option('dismissInterval') ? _this.createDismissInterval(_this.option('dismissInterval')) : null;
    /**
    * Does this component have a dismiss button?
    * @type {Boolean}
    */

    _this.isDismissable = _this.option('isDismissable');
    /**
    * Should this component be destroyed when it is dismissed.
    * @type {Boolean}
    */

    _this.destroyOnDismiss = _this.option('destroyOnDismiss');
    /**
    * The root element.
    * @type {HTMLElement|null} If this is not provided a new element will be created.
    */

    _this.element = _this.option('element');

    if (!_this.element) {
      _this.createRootElement();

      _this.parent.appendChild(_this.element);
    }

    _this.element.setAttribute('data-bulma-attached', 'attached');
    /**
    * The element used to close the component.
    * @type {HTMLElement}
    */


    _this.closeButton = _this.option('closeButton', _this.createCloseButton());

    if (_this.body) {
      _this.insertBody();
    }

    if (_this.color) {
      _this.setColor();
    }

    return _this;
  }
  /**
   * Create the main element.
   * @return {undefined}
   */


  _createClass(DismissableComponent, [{
    key: "createRootElement",
    value: function createRootElement() {
      this.element = document.createElement('div');
      this.element.classList.add(this.name);
      this.hide();
    }
    /**
     * Show the component.
     * @return {undefined}
     */

  }, {
    key: "show",
    value: function show() {
      this.element.classList.remove('is-hidden');
    }
    /**
     * Hide the component.
     * @return {undefined}
     */

  }, {
    key: "hide",
    value: function hide() {
      this.element.classList.add('is-hidden');
    }
    /**
     * Insert the body text into the component.
     * @return {undefined}
     */

  }, {
    key: "insertBody",
    value: function insertBody() {
      this.element.innerHTML = this.body;
    }
    /**
     * Create the element that will be used to close the component.
     * @return {HTMLElement} The newly created close button
     */

  }, {
    key: "createCloseButton",
    value: function createCloseButton() {
      var closeButton = document.createElement('button');
      closeButton.setAttribute('type', 'button');
      closeButton.classList.add('delete');
      return closeButton;
    }
    /**
     * Create an interval to dismiss the component after the set number of ms.
     * @param  {int} interval The time to wait before dismissing the component
     * @return {undefined}
     */

  }, {
    key: "createDismissInterval",
    value: function createDismissInterval(interval) {
      var _this2 = this;

      return setInterval(function () {
        _this2.handleCloseEvent();
      }, interval);
    }
    /**
     * Insert the close button before our content.
     * @return {undefined}
     */

  }, {
    key: "prependCloseButton",
    value: function prependCloseButton() {
      this.element.insertBefore(this.closeButton, this.element.firstChild);
    }
    /**
     * Setup the event listener for the close button.
     * @return {undefined}
     */

  }, {
    key: "setupCloseEvent",
    value: function setupCloseEvent() {
      this.closeButton.addEventListener('click', this.handleCloseEvent.bind(this));
    }
    /**
     * Handle the event when our close button is clicked.
     * @return {undefined}
     */

  }, {
    key: "handleCloseEvent",
    value: function handleCloseEvent() {
      if (this.destroyOnDismiss) {
        this.destroy();
      } else {
        this.hide();
      }
    }
    /**
     * Set the colour of the component.
     * @return {undefined}
     */

  }, {
    key: "setColor",
    value: function setColor() {
      this.element.classList.add('is-' + this.color);
    }
    /**
     * Destroy the component, removing the event listener, interval and element.
     * @return {undefined}
     */

  }, {
    key: "destroy",
    value: function destroy() {
      if (this.closeButton) {
        this.closeButton.removeEventListener('click', this.handleCloseEvent.bind(this));
      }

      clearInterval(this.dismissInterval);
      this.parent.removeChild(this.element);
      this.parent = null;
      this.element = null;
    }
  }], [{
    key: "defaultOptions",
    value:
    /**
     * Returns an object containing the default options for this plugin.
     * @returns {object} The default options object.
     */
    function defaultOptions() {
      return {
        isDismissable: false,
        destroyOnDismiss: true,
        element: null
      };
    }
  }]);

  return DismissableComponent;
}(Plugin);

export { DismissableComponent as default };